import script from "./destroy.vue?vue&type=script&setup=true&lang=js"
export * from "./destroy.vue?vue&type=script&setup=true&lang=js"

import "./destroy.vue?vue&type=style&index=0&id=42bd5915&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42bd5915"]])

export default __exports__